<template>
  <div class="container" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar
      title="卡券查询"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    /> -->

    <van-tabs v-model="active" @change="tabChange">
      <van-tab name="index0" :title="'今日绑定（' + todayBindTotal + '）'">
        <van-cell
          size="large"
          title
          style="text-align: left"
          v-for="item in todayList"
          :key="item.id"
        >
          <template #label>
            <div class="flexContainer">
              <div class="left">
                <div style="margin: 0 0 10px 0">
                  <label>卡券编号:</label>&ensp;
                  <label style="color: black">{{ item.cardNo }}</label>
                </div>
                <div>
                  <label>绑定时间:</label>&ensp;
                  <label style="color: black">{{ item.bindTime }}</label>
                </div>
              </div>
              <div class="right">
                <van-button @click="unbind(item.cardNo,item.id)" type="default"
                  >注销</van-button
                >
              </div>
            </div>
          </template>
        </van-cell>
        <van-pagination
          v-model="todayBindCurrentPage"
          v-show="todayBindTotal != 0"
          :total-items="todayBindTotal"
          :items-per-page="pageSize"
          style="margin: 20px 0 20px 0"
          @change="todayBindPageChange"
        />
      </van-tab>

      <van-tab name="index1" :title="'已绑定（' + bindTotal + '）'">
        <van-cell
          size="large"
          title
          style="text-align: left"
          v-for="item in bindList"
          :key="item.id"
        >
          <template #label>
            <div class="flexContainer">
              <div class="left">
                <div style="margin: 0 0 10px 0">
                  <label>卡券编号:</label>&ensp;
                  <label style="color: black">{{ item.cardNo }}</label>
                </div>
                <div>
                  <label>绑定时间:</label>&ensp;
                  <label style="color: black">{{ item.bindTime }}</label>
                </div>
              </div>
              <div class="right">
                <van-button @click="unbind(item.cardNo,item.id)" type="default"
                  >注销</van-button
                >
              </div>
            </div>
          </template>
        </van-cell>
        <van-pagination
          v-model="bindCurrentPage"
          v-show="bindTotal != 0"
          :total-items="bindTotal"
          :items-per-page="pageSize"
          style="margin: 20px 0 20px 0"
          @change="bindPageChange"
        />
      </van-tab>
      <van-tab name="index2" :title="'未绑定（' + unBindTotal + '）'">
        <van-cell
          size="large"
          title
          style="text-align: left"
          v-for="item in unbindList"
          :key="item.id"
        >
          <template #label>
            <div style="margin: 0 0 10px 0">
              <label>卡券编号:</label>&ensp;
              <label style="color: black">{{ item.cardNo }}</label>
            </div>
          </template>
        </van-cell>
        <van-pagination
          v-model="unBindCurrentPage"
          v-show="unBindTotal != 0"
          :total-items="unBindTotal"
          :items-per-page="pageSize"
          style="margin: 20px 0 20px 0"
          @change="unBindPageChange"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import api from "../../common/js/api";
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      active: 0, //tab激活的index
      todayList: [], //今日绑定的卡券
      bindList: [], //已绑定的卡券
      unbindList: [], //未绑定的卡券
      openId: "",
      pageSize: 12,
      todayBindCurrentPage: 1,
      todayBindTotal: 0,
      bindCurrentPage: 1,
      bindTotal: 0,
      unBindCurrentPage: 1,
      unBindTotal: 0,
    };
  },

  components: {},

  computed: {},

  created() {
    var openId = localStorage.getItem("openId");
    // var openId = "objUkwwenMEm4QfJcImDARnMUeP4";
    if (!openId) {
      this.$router.replace("/merchantBind");
    } else {
      this.openId = openId;
    }
    this.getTodayList();
    this.getBindList();
    this.getUnBindList();
  },

  mounted() {},

  methods: {
    unbind(idCard,cardId) {
      this.$dialog
        .confirm({
          title: "注销确认",
          message: "确认注销卡号为" + idCard + "的卡券吗？",
        })
        .then(() => {
          this.$post(api.unBind, {
            id: cardId,
          }).then((res) => {
            if (res.success) {
              this.$toast.success(res.message);
              this.getTodayList();
              this.getBindList();
              this.getUnBindList();
            } else {
              this.$toast(res.message);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getTodayList() {
      this.$post(api.getTodayList, {
        openId: this.openId,
        optionsId: this.$route.query.id,
        pageNum: this.todayBindCurrentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.todayBindTotal = res.data.today.total;
          this.todayList = res.data.today.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    getBindList() {
      this.$post(api.getBindList, {
        openId: this.openId,
        optionsId: this.$route.query.id,
        pageNum: this.bindCurrentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.bindTotal = res.data.bind.total;
          this.bindList = res.data.bind.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    getUnBindList() {
      this.$post(api.getUnBindList, {
        openId: this.openId,
        optionsId: this.$route.query.id,
        pageNum: this.unBindCurrentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.unBindTotal = res.data.total;
          this.unbindList = res.data.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    //返回
    onClickLeft() {
      this.$router.replace({
        path: "/merchantBind",
        query: { voucherCode: this.$route.query.voucherCode },
      });
    },
    todayBindPageChange() {
      this.getTodayList();
    },
    bindPageChange() {
      this.getBindList();
    },
    unBindPageChange() {
      this.getUnBindList();
    },
    tabChange(name) {
      switch (name) {
        case "index0":
          this.getTodayList();
          break;
        case "index1":
          this.getBindList();
          break;
        case "index2":
          this.getUnBindList();
          break;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
}
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  .left {
    display: flex;
    flex-direction: column;
  }
  .right {
    display: flex;
    ::v-deep .van-button {
      height: 30px;
    }
  }
}
</style>